<template>
    <zen-message-modal :isOpen="isOpen" title="Reset password?">
        Clicking the reset button below will send the user an email with a link
        to allow for resetting the password.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
            >
                Reset
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ResetPasswordModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
